import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import MyMultiSelect from '../../components/MyMultiSelect';
import * as API from '../../framework/API/api';
import { ENTITYNAME, TRANSMISSION_STATUS } from '../../framework/constant/constant';
import { useTranslation } from '../../locale/useTranslation';
import NodeTreeViewForm from '../../modules/MediaLibrary/NodeTreeView/NodeTreeViewForm';
import { EditPageHeader } from '../../components/EditPageHeader';
import { toast } from 'react-toastify';
import CollectionSelection from '../forms/CollectionSelection';

const CreateTransmissionForm = (props) => {

    const { onClose, onSubmit } = props;

    const lang = useTranslation();

    const [parentNodes, setParentNodes] = useState([]);
    const [ottPlatforms, setOttPlatforms] = useState([]);

    const [dataItem, setDataItem] = useState({
        ParentNodes: [],
        Nodes: [],
        Offers: [],
        Ott_Platforms: []
    })
    const [showNodePopup, setShowNodePopup] = useState(false);
    const [showOfferSelectionCollection, setShowOfferSelectionCollection] = useState(false);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let ottPlatformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "!=", true] });
        setOttPlatforms(ottPlatformRes?.data ?? []);
        let parentNodeRes = await API.getDataLookup(ENTITYNAME.Nodes, { query: ["Archive", "!=", true] });
        parentNodeRes = parentNodeRes?.data ?? [];
        let root = parentNodeRes?.filter((n) => !n.ParentNode);
        let vodChannelsArray = [];
        const searchChild = (parent) => {
            parentNodeRes?.forEach(n => {
                if (n?.ParentNode == parent._id) {
                    vodChannelsArray.push(parent);
                    searchChild(n);
                }
            });
        }
        root?.forEach(n => {
            searchChild(n);
        })
        setParentNodes(vodChannelsArray);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const handleSelectedNodes = (nodes) => {
        setDataItem({ ...dataItem, Nodes: nodes });
        setShowNodePopup(false);
    }

    const handleOffersSelected = (dataList) => {
        setDataItem({ ...dataItem, Offers: dataList });
    }

    const isValid = () => {
        if (dataItem.ParentNodes.length == 0) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.please_select_vod_channels_error_message}</div>
                </div>
            );
            return false;
        }
        if (dataItem.Nodes.length == 0) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.please_select_nodes_error_message}</div>
                </div>
            )
            return false;
        }
        if (dataItem.Offers.length == 0) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.please_select_offer_error_message}</div>
                </div>
            )
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            Offers: dataItem?.Offers,
            Status : TRANSMISSION_STATUS.UnPublished,
            ParentNodes: dataItem?.ParentNodes,
            Nodes: dataItem?.Nodes,
            Ott_Platforms: dataItem?.Ott_Platforms
        }
        onSubmit(finalData);
    }

    return (
        <BossDialog title="Attach Nodes" width='400px' onClose={onClose}>
            <EditPageHeader showTitle={false} saveButtonTitle={lang.add_button_text} onSubmit={handleSubmit} onCancel={onClose} />
            <div className='row'>
                <div className='col-12 mt-2'>
                    <label>{lang.vod_channels_label} *</label>
                    <MyMultiSelect
                        data={parentNodes}
                        name="ParentNodes"
                        dataItemKey="_id"
                        textField="Name"
                        value={dataItem.ParentNodes}
                        onChange={onChange}
                    />
                </div>
                <div className='col-12 mt-2'>
                    <label>{lang.nodes_label} *</label>
                    <div className='d-flex'>
                        <MyMultiSelect
                            data={[]}
                            name="Nodes"
                            dataItemKey="_id"
                            textField="Name"
                            style={{ flex: 1, width: "320px", marginRight: "10px" }}
                            value={dataItem.Nodes}
                            onChange={onChange}
                        />
                        <button
                            type="button"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                            style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                            onClick={() => setShowNodePopup(true)}
                            title={lang.attach_nodes_button_tooltip}
                        >
                            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div className='col-12 mt-2'>
                    <label>{lang.offer_label} *</label>
                    <div className='d-flex'>
                        <MyMultiSelect
                            data={[]}
                            name="Offers"
                            dataItemKey="_id"
                            textField="Title"
                            style={{ flex: 1, width: "320px", marginRight: "10px" }}
                            value={dataItem.Offers}
                            onChange={onChange}
                            disabled={true}
                        />
                        <button
                            type="button"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                            style={{ width: "28px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
                            onClick={() => setShowOfferSelectionCollection(true)}
                            title={lang.select_offers_label}
                        >
                            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div className='col-12 mt-2'>
                    <label>{lang.platform_label} *</label>
                        <MyMultiSelect
                            data={ottPlatforms}
                            name="Ott_Platforms"
                            dataItemKey="_id"
                            textField="Description"
                            value={dataItem.Ott_Platforms}
                            onChange={onChange}
                        />
                </div>
            </div>
            {showNodePopup && <BossDialog title={lang.select_nodes_dialog_header} width='600px' onClose={() => setShowNodePopup(false)}>
                <NodeTreeViewForm selectedNodeIds={dataItem?.ParentNodes?.map(n => n?._id) ?? []} isSaveButton={true} isMultiSelect={true} onClose={() => setShowNodePopup(false)} handleSelectedNodes={handleSelectedNodes} />
            </BossDialog>}
            {showOfferSelectionCollection && <CollectionSelection title={lang.select_offers_label} entityname={ENTITYNAME.OFFER} setDataList={handleOffersSelected} closeForm={() => setShowOfferSelectionCollection(false)} mode={'multiple'} width={"50vw"} showCreate={true} path={`/home/offer`} />}
        </BossDialog>
    )
}

export default CreateTransmissionForm